// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--lw0U1","title":"_02712f2b3b--title--_Re3I","content":"_02712f2b3b--content--d5w96"};